"use client";
import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import SlideCarousel from "@/components/SlideCarousel";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchListingData, modalHelper } from "@/components/services/QueryDataHelper";
import Link from "next/link";

function CommunityPage({community, special}:{community:string, special?:boolean}) {
  const queryClient = useQueryClient();
  const { setModal, setModalVideo, setSubdivision } = modalHelper(queryClient);

  const { data: currentData, error, isLoading } = useQuery({ queryKey: ["LISTING-DATA", community], queryFn: () => fetchListingData("community", community), staleTime: 300000 });

  const subdivision = community.replace(/_/g, " ").replace(/-/g, " ").replace(/  /g, " -").trim().toLowerCase().replace(/(^\w)|(\s\w)/g, (letter: string) => letter.toUpperCase());

  useEffect(() => {
    if(special) {
      setModal("speciallist");
    }
    if(community) {
      setSubdivision(community);
    }
}, [])   

  //   const listings = useSelector(selectListings);
  //   const isLoading = useSelector(selectFetching);
  //   const dispatch = useDispatch();  

  //   useEffect(() => {
  //       if(community) dispatch(setSubdivision(community));
  //   }, [])   

  //   useEffect(() => {
  //     if(community) dispatch(setSubdivision(community));
  // }, [community])   


  return (
    <>
      <section className="StyledSection">
        <Container>
          <Row>
            <Col>
              <Card bg="trans-white">
                <Card.Body>
                  <Card.Title><h1 className="blue-color">Properties for sale in {subdivision}</h1></Card.Title>
                  <Card.Subtitle>
                    {isLoading && <h2>Please allow a moment to load the active property listings for sale in {subdivision}.</h2>}
                    {!isLoading && (currentData?.length > 0 ?
                      <h2>Below you will find the active property listings for sale in {subdivision}.</h2>
                      :
                      <h2>There are no active listings for sale in this community.</h2>
                    )}
                  </Card.Subtitle>
                  <Card.Text as="div">
                    {isLoading && <p className="indent">In addition to these we have off-market properties and resources to help you find the home you are seeking. We will be in touch shortly to discuss your home search. If you wish to get immediate assistance please call RES Luxury Group, eXp Realty: <Link href="tel:+13527941426" aria-label="Click to automatically dial from mobile device a real estate agent" title="Click to automatically dial from mobile device a real estate agent"><span itemProp="telephone">352.794.1426</span></Link>.</p>}
                    {!isLoading && (currentData?.length > 0 ?
                      <p className="indent">In addition to these we have off-market properties and resources to help you find the home you are seeking. We will be in touch shortly to discuss your home search. If you wish to get immediate assistance please call RES Luxury Group, eXp Realty: <Link href="tel:+13527941426" aria-label="Click to automatically dial from mobile device a real estate agent" title="Click to automatically dial from mobile device a real estate agent"><span itemProp="telephone">352.794.1426</span></Link>.</p>
                      :
                      <p className="indent">That"s not a problem however, as we have off-market properties and resources to help you find the home you are seeking. We will be in touch shortly to discuss your home search. If you wish to get immediate assistance please call RES Luxury Group, eXp Realty: <Link href="tel:+13527941426" aria-label="Click to automatically dial from mobile device a real estate agent" title="Click to automatically dial from mobile device a real estate agent"><span itemProp="telephone">352.794.1426</span></Link>.</p>
                    )}

                    <SlideCarousel className="featured-carousel" slideType="community" queryValue={community} slideCount={16} controls={false} cardWrapper={false} bg="trans-black" />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default CommunityPage;